<form class="form vc-admin-form vc-admin-site-form" [formGroup]="form" (ngSubmit)="execute()" novalidate>
  @if (showIntro) {
  <header class="vc-admin-form__intro">
    <h3 class="vc-admin-form__title">{{ formTitleKey | translate }}</h3>
    <p class="vc-admin-form__subtitle">{{ formDescriptionKey | translate }}</p>
  </header>
  }

  <section class="vc-admin-form__section">
    <h4 class="vc-admin-form__section-title">{{ 'COMMON.INFO' | translate }}</h4>
    @if (!loadingCostHint && costHint) {
    <div class="vc-admin-form__info">
      <i class="fas fa-euro-sign"></i>
      <p>
        @if (costHint.additional_charge) {
        {{
        'ADMIN.CUSTOMERS.COST_HINTS.SITE_WITH_COST'
        | translate: { amount: (costHint.effective_price | number: '1.2-2') }
        }}
        } @else {
        {{ 'ADMIN.CUSTOMERS.COST_HINTS.SITE_NO_EXTRA' | translate }}
        }
      </p>
    </div>
    }
    <div class="grid">
      <div class="col-12 md:col-6">
        <div class="field">
          <label for="name">{{ 'COMMON.SITE_NAME' | translate }} *</label>
          <input id="name" pInputText formControlName="name" fluid />
          <small id="site-name-help" class="p-error"
            *ngIf="(submitted || form.controls['name'].touched) && errors.name">
            {{ errors.name | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field">
          <label for="address">{{ 'COMMON.SITE_ADDRESS' | translate }}</label>
          <input id="address" pInputText formControlName="address" fluid />
          <small id="site-address-help" class="p-error"
            *ngIf="(submitted || form.controls['address'].touched) && errors.address">
            {{ errors.address | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field">
          <label for="city">{{ 'COMMON.CITY' | translate }}</label>
          <input id="city" pInputText formControlName="city" fluid />
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field">
          <label for="province">{{ 'COMMON.PROVINCE' | translate }}</label>
          <input id="province" pInputText formControlName="province" fluid />
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field">
          <label for="countryCode">{{ 'COMMON.COUNTRY' | translate }}</label>
          <input id="countryCode" pInputText formControlName="country_code" fluid />
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field">
          <label for="postalCode">{{ 'COMMON.POSTAL_CODE' | translate }}</label>
          <input id="postalCode" pInputText formControlName="postal_code" fluid />
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field">
          <label for="email">{{ 'COMMON.SITE_EMAIL' | translate }}</label>
          <input id="email" pInputText formControlName="email" fluid />
          <small id="site-email-help" class="p-error"
            *ngIf="(submitted || form.controls['email'].touched) && errors.email">
            {{ errors.email | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field">
          <label for="phone">{{ 'COMMON.SITE_PHONE' | translate }}</label>
          <input id="phone" pInputText formControlName="phone" fluid />
          <small id="site-phone-help" class="p-error"
            *ngIf="(submitted || form.controls['phone'].touched) && errors.phone">
            {{ errors.phone | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-6" *ngIf="showClinicalHistoryStructureControl">
        <div class="field">
          <label for="clinical-history-structure">{{
            'ADMIN.SITES.DETAIL.CLINICAL_HISTORY_STRUCTURE_LABEL' | translate
            }}</label>
          <p-dropdown inputId="clinical-history-structure" formControlName="clinical_history_structure_id"
            [options]="clinicalHistoryStructureOptions" optionLabel="label" optionValue="value"
            [loading]="loadingClinicalHistoryStructures" appendTo="body"></p-dropdown>
          <small class="vc-admin-color-control__hint">
            {{ 'ADMIN.SITES.DETAIL.CLINICAL_HISTORY_STRUCTURE_HINT' | translate }}
          </small>
        </div>
      </div>
    </div>
  </section>

  <section class="vc-admin-form__section">
    <h4 class="vc-admin-form__section-title">{{ 'COMMON.APPEARANCE' | translate }}</h4>
    <div class="grid">
      <div class="col-12 md:col-6">
        <div class="field">
          <label for="color">{{ 'COMMON.COLOR' | translate }}</label>
          <div class="vc-admin-color-control">
            <div class="vc-admin-color-control__inputs">
              <input id="color" class="vc-admin-color-control__picker" type="color" [value]="colorPreview"
                (input)="onColorInput($any($event.target).value)" />
              <input id="color-code" pInputText [value]="colorPreview"
                (input)="onColorInput($any($event.target).value)" />
            </div>

            <div class="vc-admin-color-control__presets">
              @for (preset of colorPresets; track preset) {
              <button type="button" class="vc-admin-color-control__preset" [class.is-active]="preset === colorPreview"
                [style.background]="preset" [attr.aria-label]="('COMMON.COLOR' | translate) + ' ' + preset"
                (click)="selectColorPreset(preset)"></button>
              }
            </div>
          </div>
          <small class="vc-admin-color-control__hint">
            {{ 'ADMIN.FORMS.SITE.COLOR_HINT' | translate }}
          </small>
        </div>
      </div>
    </div>
  </section>

  <app-admin-form-actions primaryLabelKey="COMMON.SAVE" [submitting]="submitting"></app-admin-form-actions>
</form>